import styled from 'styled-components';
import { OrderPanelStyled, PriceCss } from '../OrderPanelStyled';
import { rem } from 'polished';

export const OrderPanelStyledAP = styled(OrderPanelStyled)`
    .wrapper {
        .section {
            .order-panel-price-container {
                ${PriceCss}
                .calculator {
                    color: unset;

                    .linkIcon {
                        svg {
                            path {
                                fill: black;
                            }
                        }
                    }
                }

                .content {
                    .body {
                        margin-top: ${rem('8px')};

                        .body-wrapper {
                            .or,
                            .price {
                                line-height: ${rem('20px')};
                            }

                            .infoIcon {
                                .icon-wrapper {
                                    padding-top: unset;
                                }
                            }
                        }
                    }
                }
            }
        }
        .desktopContactSection {
            .modalLink {
                color: ${({ theme }) => theme.colors.primary};
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                font-weight: normal;

                svg {
                    height: 7px;

                    path {
                        fill: ${({ theme }) => theme.colors.primary};
                        stroke: ${({ theme }) => theme.colors.primary};
                    }
                }

                &:hover,
                &:focus-visible {
                    text-decoration: underline;
                    color: ${({ theme }) => theme.colors.primary};

                    svg {
                        path {
                            fill: ${({ theme }) => theme.colors.primary};
                            stroke: ${({ theme }) => theme.colors.primary};
                        }
                    }
                }
            }

            .phoneLink {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .mobileContactSection {
        background: ${({ theme }) => theme.colors.black};
        padding: ${rem('10px')};

        .label {
            font-weight: normal;
        }

        .label,
        .phone {
            font-size: ${rem('12px')};
            white-space: nowrap;
        }
    }
`;
